module.exports = __webpack_public_path__ + "media/logo-animation.404995f4.mp4";